var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandortWei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 64.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666666;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    className: "cls-1",
    d: "M23,.3C10.31,.29,0,10.41,0,22.91c0,.01,0,.02,0,.03C0,39.94,23,65.02,23,65.02c0,0,23-25.08,23-42.07,0-12.5-10.27-22.64-22.97-22.65-.01,0-.02,0-.03,0Zm0,30.74c-4.53,0-8.21-3.62-8.21-8.08s3.67-8.08,8.21-8.08c4.53,0,8.21,3.62,8.21,8.08h0c0,4.46-3.67,8.08-8.21,8.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandortWei);
export default __webpack_public_path__ + "static/media/Standort_weiß.3dd306b8572ff2814651237b7e382ba1.svg";
export { ForwardRef as ReactComponent };